<template lang="pug">
  a-modal(
    :title="title"
    :maskClosable="false"
    :visible="true"
    :confirmLoading="loading"
    @ok="onOk()"
    :okText="$t('components.change_password_modal.tpl.save')"
    @cancel="hideModal()"
    :cancelText="$t('components.change_password_modal.tpl.cancel')"
  )
    a-form(
      @submit="onOk"
    )
      a-form-item(
        :label="$t('components.change_password_modal.tpl.current_password')"
        :extra="$t('components.change_password_modal.tpl.current_password_extra')"
      )
        a-input(
          v-model="oldPassword"
          :disabled="loading"
          type="password"
        )
      hr
      a-form-item(
        :label="$t('components.change_password_modal.tpl.new_password')"
      )
        a-input(
          :placeholder="$t('components.change_password_modal.tpl.new_password_placeholder')"
          v-model="newPassword1"
          :disabled="loading"
          type="password"
        )
        password-meter(
          :placeholder="$t('components.change_password_modal.tpl.new_password_2_placeholder')"
          required
          v-model="newPassword2"
          :disabled="loading"
          defaultClass="ant-input"
          :showPassword="false"
          :badge="false"
          :secureLength=6
        )
      a-alert(
        v-if="errors.length > 0"
        :showIcon="true"
        :message="$t('components.change_password_modal.tpl.error_title')"
        type="warning"
      )
        div(
          slot="description"
          v-for="(error, key) in errors"
        ) {{error}}

</template>

<script>
import PasswordMeter from 'vue-password-strength-meter';

import { fetchToken } from '@/api';

import {
  eq,
  isEmpty,
  size,
} from 'lodash';

import {
  mapActions,
  mapState,
} from 'vuex';

export default {
  components: {
    PasswordMeter,
  },
  data() {
    return {
      title: this.$t('components.change_password_modal.js.title'),
      loading: false,
      errors: [],
      newPassword1: '',
      newPassword2: '',
      oldPassword: '',
    };
  },
  computed: {
    ...mapState('login', [
      'user',
      'instance',
      'FORMATTED_TOKEN',
    ]),
  },
  methods: {
    ...mapActions('login', [
      'restoreUserPasswordAndSetUser',
    ]),
    async hideModal() {
      await this.$emit('hide');
    },
    async validatePassword() {
      if (isEmpty(this.newPassword1) || isEmpty(this.newPassword2)) {
        this.errors.push(this.$t('components.change_password_modal.js.errors.should_enter_new_password'));
      } else if (!eq(this.newPassword1, this.newPassword2)) {
        this.errors.push(this.$t('components.change_password_modal.js.errors.passwords_do_not_match'));
      } else if (eq(this.newPassword1, this.oldPassword)) {
        this.errors.push(this.$t('components.change_password_modal.js.errors.new_password_should_be_different'));
      } else if (size(this.newPassword1) < 6) {
        this.errors.push(this.$t('components.change_password_modal.js.errors.new_password_must_have_more_than_6_characters'));
      }
    },
    async restorePassword() {
      await this.restoreUserPasswordAndSetUser({
        userEntity: {
          id: this.user.id,
          username: this.user.username,
          password: this.newPassword1,
          audit: {
            userId: this.user.id,
          },
        },
        token: this.FORMATTED_TOKEN,
      });
    },
    async onOk() {
      this.errors = [];
      try {
        // verificar usuario y password con la obtención de token
        await fetchToken({
          instance: this.instance,
          username: this.user.username,
          password: this.oldPassword,
        });
      } catch (e) {
        this.errors.push(this.$t('components.change_password_modal.js.errors.invalid_current_password'));
      }

      this.validatePassword();

      if (isEmpty(this.errors)) {
        this.loading = true;
        try {
          await this.restorePassword();
          await this.hideModal();

          this.$notification.success({
            message: this.$t('components.change_password_modal.js.errors.new_password_message'),
            description: this.$t('components.change_password_modal.js.errors.new_password_description'),
            placement: 'bottomRight',
            duration: 4,
          });
        } catch (e) {
          this.$message.error(this.$t('components.change_password_modal.js.errors.error_saving_password'), 2);
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.Password {
  max-width: none;
}
</style>
